import { Bundle } from '@smiles/core-defs';

export const getChannelFromBundle = () => {
  const channel: string = Bundle.getValue('config').channel;
  return channel.charAt(0) + channel.substring(1).toLocaleLowerCase();
};

export const removeHtmlTags = (htmlText: string, replacer = '') => {
  return htmlText.replace(/<\/?.*?>/g, replacer);
};

export const removeDoubleEspaces = (text: string) => {
  return text.replace(/\s{2,}/g, ' ');
};

const removeHtmlTagsStartAndKeepBetweenText = (text: string) => {
  return text.replace(/^(<[^>]*>)+/g, '');
};

const removeHtmlEndAndKeepBetweenText = (text: string) => {
  return text.replace(/(<[^>]+>)([\s\S]?)(<[^>]+>)*$/g, '');
};

export const removeHtmlTagsKeepBrTag = (text: string) => {
  return text.replace(/<(?!br\b)[^>]*>/g, '');
};

export const removeHtmlTagsAndKeepTagsBetweenText = (text: string) => {
  const newText = removeHtmlTagsStartAndKeepBetweenText(text);
  return removeHtmlEndAndKeepBetweenText(newText);
};

export const duplicateBrTags = (text: string) => {
  return text.replace(/(<br\s*\/?>)+/g, '<br><br>');
};

export const dictionaryFactory = <T extends Record<string, unknown>>(
  dictionary: T,
) => {
  return new Proxy(dictionary, {
    get: (target, prop) => (prop in target ? target[prop as string] : prop),
  });
};

export const parseStringToUpperCaseAndCompareIfIsTrue = (
  stringToCompare: string,
) => {
  return stringToCompare.toUpperCase() === 'TRUE';
};

export const getAccessTokenFromBudle = () => {
  const key = Bundle.getValue('TOKEN_TOKEN_AUTH_USER');
  return JSON.parse(key);
};
